module.exports = function() {
  return new Worker(__webpack_public_path__ + "e09f6364c434e0b44076.worker.js");
};